import { useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';

import './loading-indicator.scss';

const LoadingIndicator = (): React.JSX.Element => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(true), 300);
    return (): void => clearTimeout(timer);
  }, []);

  if (showLoader) {
    return <LinearProgress data-testid="loading-indicator" />;
  }
  return <></>;
};

export default LoadingIndicator;
